import { Component } from '@angular/core';

@Component({
  selector: 'app-charter',
  standalone: true,
  imports: [],
  templateUrl: './charter.component.html',
  styleUrl: './charter.component.scss'
})
export class CharterComponent {

}
